import { render, staticRenderFns } from "./ErgebnisseTable.vue?vue&type=template&id=bde655a4&scoped=true"
import script from "./ErgebnisseTable.vue?vue&type=script&lang=js"
export * from "./ErgebnisseTable.vue?vue&type=script&lang=js"
import style0 from "./ErgebnisseTable.vue?vue&type=style&index=0&id=bde655a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde655a4",
  null
  
)

export default component.exports